import { put, takeLatest, all } from 'redux-saga/effects'

import { ProjectEventType } from '@tabeeb/enums'
import { signalrEvents, signalrConstants } from '../../signalr'

import * as actions from '../actions'
import * as notificationActions from '../../notification/actions'

function* onNotifyProject(action) {
  const [notification] = action.payload

  if (notification.EventType === ProjectEventType.IterationAdded) {
    yield put(actions.getIterationById.request({ Id: notification.IterationId }))
    return
  }

  if (notification.EventType === ProjectEventType.IterationTrainingStatusUpdated) {
    yield put(
      actions.updateIterationTrainingStatus({
        Id: notification.IterationId,
        Status: notification.Status,
        ErrorMessage: notification.ErrorMessage,
        WarningMessage: notification.WarningMessage,
      })
    )

    yield put(notificationActions.onAddInfoNotification({ message: "Iteration's status has been updated" }))
    return
  }

  if (notification.EventType === ProjectEventType.IterationDeploymentStatusUpdated) {
    yield put(
      actions.updateIterationDeploymentStatus({
        Id: notification.IterationId,
        DeploymentStatus: notification.DeploymentStatus,
        ExpirationTime: notification.ExpirationTime,
      })
    )

    yield put(notificationActions.onAddInfoNotification({ message: "Iteration's deployment status has been updated" }))
  }
}

function* updateProject() {
  yield all([
    // signalr
    takeLatest(signalrEvents[signalrConstants.aiServiceHubName].onNotifyProject, onNotifyProject),
  ])
}

export default updateProject
